import React, { useState, useContext, useRef, useEffect } from 'react'
import { handleScrollRef } from '../../../utils/safe'
import MainProdotto from '../../molecules/MainProdotto/MainProdotto'
import DettagliProdotto from '../../molecules/DettagliProdotto/DettagliProdotto'
import FormPersonalizzazione from '../../organisms/FormPersonalizzazione/FormPersonalizzazione'
import ProdottoPersonalizzazioneCard from '../../molecules/ProdottoPersonalizzazioneCard/ProdottoPersonalizzazioneCard'
import { QuantitaContext } from '../../../context/QuantitaContext'
import NewTableSchedaProdotto from '../../molecules/NewTableSchedaProdotto/NewTableSchedaProdotto'
import ModificaArticoli from '../../organisms/ModificaArticoli/ModificaArticoli'
import NewModal from '../../molecules/NewModal/NewModal'
import ModalBlocks from '../../molecules/ModalBlocks/ModalBlocks'
import { Button } from '../../atoms'
import LoadingSvg from '../../atoms/Loading/Loading'
import NonHaiTrovatoBox from '../../molecules/NonHaiTrovatoBox/NonHaiTrovatoBox'
import AttributoSelector from '../../organisms/AttributoSelector/AttributoSelector'
import OrdineRiepilogoCard from '../../molecules/OrdineRiepilogoCard/OrdineRiepilogoCard'
import useTrans from '../../../hooks/useTrans'
import ProdottoContextProvider from '../../../context/ProdottoContext'

//bisognerà oscurare "Le nostre Scelte" -> nel caso dovesse esistere il service Gift
const ProdottoTemplate = ({
  prodotto,
  selectedArticolo,
  selectedTaglia,
  setSelectedTaglia,
  selectedColor,
  HandleColorClick,
  prodottoWishlist,
  ArrowClick,
  AddToCart,
  utente,
  AddToCartMain,
  carrello,
  service_gift,
  setCarrello,
  SaveLater,
  deleteRigaCarrello,
  changingPreventivo,
  OnClickRichiedi,
  consegna,
  setSelectedColor,
  OrdinaSubito,
  setReload,
}) => {
  const {
    handleQuantita,
    onChangeInputQuantita,
    disabled,
    isValid,
    getError,
    getQuantita,
    quantita,
  } = useContext(QuantitaContext)
  const refTableSchedaProdotto = useRef(null)
  const refDettagliScheda = useRef(null)
  const refPersonalizzazione = useRef(null)
  const [showPersonalizzaForm, setShowPersonalizzaForm] = useState(false)
  const [showModificaArticoli, setShowModificaArticoli] = useState(false)
  const [editArticoloProps, setEditArticoloProps] = useState()
  const t = useTrans()
  const scrollTo = (ref) => {
    handleScrollRef(ref)
  }

  useEffect(() => {
    showPersonalizzaForm === true && scrollTo(refPersonalizzazione)
  }, [showPersonalizzaForm])

  const checkErrors = () => {
    let valid = true
    // ? E' stato aggiunto il check e il filtro per gli articolo che sono esclusi dalla personalizzazione
    const valore = quantita
      ?.filter((item) => item?.escludi_da_listino_di_stampa !== true)
      ?.reduce((previus, current) => previus + current.quantita, 0)
    !(valore >= (utente?.ignora_minimi_stampa ? 0 : prodotto?.quantita_minima_personalizzabile)) &&
      (valid = false)
    if (valid && isValid()) {
      return true
    } else {
      return false
    }
  }
  return (
    <ProdottoContextProvider>
      <div className="w-container">
        <MainProdotto
          setSelectedTaglia={setSelectedTaglia}
          utente={utente}
          indirizzo="prova"
          consegna={consegna}
          mail_campioni={prodotto.mailto_campioni}
          prodotto={prodotto}
          selectedArticolo={selectedArticolo}
          selectedTaglia={selectedTaglia}
          selectedColor={selectedColor}
          HandleColorClick={HandleColorClick}
          wishlist={prodottoWishlist}
          ArrowClick={ArrowClick}
          service_gift={service_gift}
          scrollToDettagli={() => scrollTo(refDettagliScheda)}
          scrollToTableSchedaProdotto={() => scrollTo(refTableSchedaProdotto)}
        />

        <div className="prodotto-template__cols">
          <div className="prodotto-template__main">
            {(utente || (service_gift && !service_gift.premium)) && (
              <div ref={refTableSchedaProdotto}>
                <div className="prodotto-template__block">
                  <NewTableSchedaProdotto
                    selectorTaglia={
                      selectedTaglia && (
                        <AttributoSelector
                          label={t('Taglia')}
                          Attributi={
                            prodotto?.colori?.filter((colore) => colore.id === selectedColor.id)[0]
                              ?.taglie
                          }
                          selectedAttributo={selectedTaglia}
                          setSelectedAttributo={setSelectedTaglia}
                        />
                      )
                    }
                    selectorColore={
                      selectedColor && (
                        <AttributoSelector
                          label={t('Colore')}
                          Attributi={prodotto?.colori}
                          selectedAttributo={selectedColor}
                          setSelectedAttributo={setSelectedColor}
                        />
                      )
                    }
                    utente={utente}
                    quantita={quantita}
                    setSelectedTaglia={setSelectedTaglia}
                    setSelectedColor={selectedColor}
                    showPersonalizzaForm={showPersonalizzaForm}
                    setShowPersonalizzaForm={setShowPersonalizzaForm}
                    selectedArticolo={selectedArticolo}
                    prodotto={prodotto}
                    handleQuantita={handleQuantita}
                    onChangeInputQuantita={onChangeInputQuantita}
                    disabled={disabled}
                    isValid={isValid}
                    articoliQuantita={quantita}
                    AddToCart={AddToCart}
                    service_gift={service_gift}
                    OnClickRichiedi={OnClickRichiedi}
                  />
                </div>
              </div>
            )}
            {utente && (!service_gift || service_gift?.premium) && showPersonalizzaForm && (
              <div className="prodotto-template__block" ref={refPersonalizzazione}>
                <FormPersonalizzazione
                  prodotto={prodotto}
                  setShowPersonalizzaForm={setShowPersonalizzaForm}
                  articoliQuantita={quantita?.filter(
                    (item) => item?.escludi_da_listino_di_stampa !== true
                  )}
                  prodottoId={prodotto.codice}
                  AddToCart={AddToCart}
                  ErroreQuantita={!checkErrors()}
                  setReload={setReload}
                >
                  {quantita &&
                    quantita
                      .sort((a, b) =>
                        a.codice == selectedArticolo.codice
                          ? -1
                          : b.codice == selectedArticolo.codice
                          ? 1
                          : 0
                      )
                      .filter(
                        (item) => item?.quantita > 0 && item?.escludi_da_listino_di_stampa !== true
                      )
                      .map((item) => (
                        <ProdottoPersonalizzazioneCard
                          key={item.codice}
                          prodotto={
                            prodotto.articoli.filter((element) => element.codice == item.codice)[0]
                          }
                          colore={
                            prodotto.articoli
                              .filter((element) => element.codice == item.codice)[0]
                              ?.attributi_lista.filter((element) => element.attributo == 7)[0]
                          }
                          taglia={
                            prodotto.articoli
                              .filter((element) => element.codice == item.codice)[0]
                              ?.attributi_lista.filter((element) => element.attributo == 8)[0]?.nome
                          }
                          onChangeInputQuantita={onChangeInputQuantita}
                          handleQuantita={handleQuantita}
                          quantitaMinimaPersonalizzabile={
                            utente.ignora_minimi_stampa
                              ? 0
                              : prodotto.quantita_minima_personalizzabile
                          }
                          getError={getError}
                          getQuantita={getQuantita}
                        />
                      ))}
                  {quantita?.filter(
                    (item) => item?.quantita > 0 && item?.escludi_da_listino_di_stampa !== true
                  )?.length === 0 && (
                    <p className="prodotto-template__paragraph">
                      {t('Inserire Quantità maggiore di 0')}
                    </p>
                  )}
                </FormPersonalizzazione>
              </div>
            )}
            {/* Mostro i dettagli prodotto se l'utente è loggato oppure se è servicegift vetrina */}
            {(utente || (service_gift && !service_gift.premium)) && (
              <div ref={refDettagliScheda} className="prodotto-template__block">
                <DettagliProdotto
                  selectorTaglia={
                    selectedTaglia && (
                      <AttributoSelector
                        label={t('Taglia')}
                        Attributi={
                          prodotto?.colori?.filter((colore) => colore.id === selectedColor.id)[0]
                            ?.taglie
                        }
                        selectedAttributo={selectedTaglia}
                        setSelectedAttributo={setSelectedTaglia}
                      />
                    )
                  }
                  selectorColore={
                    selectedColor && (
                      <AttributoSelector
                        label={t('Colore')}
                        Attributi={prodotto?.colori}
                        selectedAttributo={selectedColor}
                        setSelectedAttributo={setSelectedColor}
                      />
                    )
                  }
                  prodotto={prodotto}
                  selectedItem={selectedArticolo}
                  selectedColor={selectedColor}
                  selectedTaglia={selectedTaglia}
                ></DettagliProdotto>
              </div>
            )}
          </div>

          <div className="prodotto-template__sidebar">
            {/* // ! Inserire un altro Modifica Articoli da modificare da dentro OrdineRiepilogoCard */}
            {utente && (!service_gift || service_gift?.premium) && (
              <OrdineRiepilogoCard
                isLoading={changingPreventivo}
                ordine={carrello}
                AddToCartMain={AddToCartMain}
                isProdotto={true}
                prodotto={prodotto}
                SaveLater={SaveLater}
                ModificaArticoli={() => setShowModificaArticoli(true)}
                setEditArticoloProps={setEditArticoloProps}
                OrdinaSubito={OrdinaSubito}
              />
            )}

            {editArticoloProps?.initialSelectedArticolo && (
              <ModificaArticoli
                AddToCart={AddToCart}
                setCarrello={setCarrello}
                isVisible={editArticoloProps?.show}
                setVisible={(value) => {
                  const new_value = value
                  setEditArticoloProps((prev_state) => ({ ...prev_state, show: new_value }))
                }}
                preventivo={carrello}
                prodotto={prodotto}
                initialStep={editArticoloProps?.initialStep}
                initialId={editArticoloProps?.initialId}
                initialSelectedArticolo={editArticoloProps?.initialSelectedArticolo}
                initialQuantitaProps={editArticoloProps?.initialQuantita}
                service_gift={service_gift}
                key={`modifica_articoli_${editArticoloProps?.initialId}`}
              />
            )}

            {/* // ? Viene utilizzato per il Modifica Articoli con la scelta di Opzione  */}
            <ModificaArticoli
              AddToCart={AddToCart}
              setCarrello={setCarrello}
              isVisible={showModificaArticoli}
              setVisible={setShowModificaArticoli}
              preventivo={carrello}
              prodotto={prodotto}
              service_gift={service_gift}
              key={`modifica_articoli`}
            />
          </div>
        </div>
      </div>

      {/* Wide - non è dentro al container */}
      <NonHaiTrovatoBox />

      <DeleteFromRiepilogoCard
        onDelete={async () => await deleteRigaCarrello(editArticoloProps?.initialId)}
        visible={editArticoloProps?.show_delete}
        setVisible={(value) =>
          setEditArticoloProps((prev_state) => ({ ...prev_state, show_delete: value }))
        }
      />
    </ProdottoContextProvider>
  )
}

export default ProdottoTemplate

export const DeleteFromRiepilogoCard = ({ visible, setVisible, onDelete }) => {
  const [Loading, setLoading] = useState(false)
  const _handleDelete = async () => {
    setLoading(true)
    await onDelete()
    setLoading(false)
    setVisible(false)
  }
  return (
    <NewModal
      visible={visible}
      onClose={() => setVisible(false)}
      title="Sei sicuro di voler Eliminare questo articolo?"
    >
      {Loading ? (
        <LoadingSvg />
      ) : (
        <ModalBlocks.Actions>
          <Button label="Annulla" variant="secondary" onClick={() => setVisible(false)} />
          <Button
            label="Conferma e elimina"
            variant="primary"
            onClick={() => {
              onDelete && _handleDelete()
            }}
          />
        </ModalBlocks.Actions>
      )}
    </NewModal>
  )
}
